import { createContext, useContext, useState } from 'react';

export type DnDPayload =
  | { type: 'node'; nodeId: string }
  | { type: 'toolCategory'; categoryName: string; nodeIds: string[] }
  | { type: 'multiSelect'; nodeIds: string[] }
  | null;

const DnDContext = createContext<[DnDPayload, (payload: DnDPayload) => void]>([
  null,
  (_: DnDPayload) => {},
]);

export const DnDProvider = ({ children }: { children: React.ReactNode }) => {
  const [payload, setPayload] = useState<DnDPayload>(null);

  return (
    <DnDContext.Provider value={[payload, setPayload]}>
      {children}
    </DnDContext.Provider>
  );
};

export default DnDContext;

export const useDnD = () => {
  return useContext(DnDContext);
};
